import { getRoute, useLayout } from '@/functions';

export default {
    path: '/',
    component: useLayout('blank'),
    children: [
        getRoute('/oauth/google/callback', 'googleOAuthCallback', 'oauth/google_callback_page', { title: 'Google Sign In' }),
    ],
};

